import { Box, Typography } from '@material-ui/core'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { StyledRightCard } from 'pages/content/components/jobs/styled'

export const JobsNotFound = () => {
  const { isDevice } = useScreenSizes()

  return (
    <StyledRightCard minWidth={0}>
      <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column">
        <img src={`/assets/NoResults_Obsidi_illustration.svg`} alt="404 Error" width={isDevice ? "200.29px" : "290.52px"} height={isDevice ? "217.43px" : "314.06px"}/>
        <Box>
          <Typography variant="body1"><Box fontWeight={700}>No Results Found</Box></Typography>
        </Box>
        <Box mt="1em" width={isDevice ? "271px" : "unset"}>
          <Typography variant="body1">
            <Box textAlign={isDevice ? 'center' : 'left'}>No job listings match your selected criteria</Box>
          </Typography>
        </Box>
      </Box>
    </StyledRightCard>
  )
}
